/*global SVGLoader, mina */
const loaderSpeed = 400;
export default function getArticleLoader () {
  if (!window.articleLoader) {
    window.articleLoader = typeof SVGLoader !== 'undefined' ? new SVGLoader(document.getElementById('loader'), {speedIn: loaderSpeed, easingIn: mina.easeinout}) : {};
  }
  return window.articleLoader;
}



// WEBPACK FOOTER //
// ./apps/www.relic.com/src/helpers/getArticleLoader.js